import { Email, WhatsApp } from "@mui/icons-material";
import { Button, Stack } from "@mui/material";
import type { CTAButtonsProps } from "./types/CTAButtonsProps";

export function CTAButtons({ whatsappUrl, email }: CTAButtonsProps) {
  return (
    <Stack direction={{ xs: "column", sm: "row" }} spacing={3} justifyContent="center" alignItems="center" mb={2}>
      <Button
        startIcon={<WhatsApp />}
        variant="contained"
        href={whatsappUrl}
        target="_blank"
        sx={{
          backgroundColor: "#1ebe57",
          fontSize: { xs: "14px", sm: "16px", fontWeight: "bold" },
          textTransform: "uppercase",
        }}
      >
        CHAMAR NO WHATSAPP
      </Button>

      <Button
        startIcon={<Email />}
        variant="outlined"
        href={`mailto:${email}`}
        sx={{
          fontSize: { xs: "14px", sm: "16px", fontWeight: "bold" },
          textTransform: "uppercase",
        }}
      >
        ENVIE-NOS UM E-MAIL
      </Button>
    </Stack>
  );
}
